import { db, storage } from '../firebase';
import firebase from 'firebase/app';

const COLLECTION = 'gallery_images';

export async function getGalleryImages({ category = 'all', search = '' } = {}) {
  try {
    let snapshot;
    try {
      snapshot = await db.collection(COLLECTION).orderBy('createdAt', 'desc').get();
    } catch (e) {
      snapshot = await db.collection(COLLECTION).get();
    }

    let list = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt ? (data.createdAt.toDate ? data.createdAt.toDate() : new Date(data.createdAt)) : new Date(),
      };
    });

    if (category && category !== 'all') {
      list = list.filter((img) => img.category === category);
    }

    if (search && search.trim()) {
      const q = search.trim().toLowerCase();
      list = list.filter((img) => {
        const title = (img.title || '').toLowerCase();
        const desc = (img.description || '').toLowerCase();
        return title.includes(q) || desc.includes(q);
      });
    }

    return list;
  } catch (error) {
    console.error('Error fetching gallery images:', error);
    return [];
  }
}

export async function createGalleryImage(data) {
  const payload = {
    title: data.title || '',
    category: data.category || 'General',
    description: data.description || '',
    imageUrl: data.imageUrl,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  };

  const docRef = await db.collection(COLLECTION).add(payload);
  return docRef.id;
}

export async function deleteGalleryImage(id, imageUrl) {
  // Delete from Firestore
  await db.collection(COLLECTION).doc(id).delete();

  // Try to delete from Firebase Storage if it's hosted there
  if (imageUrl && imageUrl.includes('firebasestorage.googleapis.com')) {
    try {
      const ref = storage.refFromURL(imageUrl);
      await ref.delete();
    } catch (err) {
      console.warn('Could not delete file from storage, might be external or already deleted:', err);
    }
  }
}
